const isDesktop = window.innerWidth > 768;

export default isDesktop;
